export var G = 'G';
export var Svg = 'SVG';
export var View = 'VIEW';
export var Text = 'TEXT';
export var Link = 'LINK';
export var Page = 'PAGE';
export var Note = 'NOTE';
export var Path = 'PATH';
export var Rect = 'RECT';
export var Line = 'LINE';
export var Stop = 'STOP';
export var Defs = 'DEFS';
export var Image = 'IMAGE';
export var Tspan = 'TSPAN';
export var Canvas = 'CANVAS';
export var Circle = 'CIRCLE';
export var Ellipse = 'ELLIPSE';
export var Polygon = 'POLYGON';
export var Document = 'DOCUMENT';
export var Polyline = 'POLYLINE';
export var ClipPath = 'CLIP_PATH';
export var TextInstance = 'TEXT_INSTANCE';
export var LinearGradient = 'LINEAR_GRADIENT';
export var RadialGradient = 'RADIAL_GRADIENT';